import { theme } from '@features/executive-report/domain/theme';
import { ShapeProps } from '@features/powerpoint';
import { applyPyramidXOffset, applyPyramidYOffset } from './layout';
import { pyramidMetrics } from './content';

const boxWithGreenOutline = (options: ShapeProps['options']): ShapeProps => ({
  shapeName: 'rect',
  options: {
    fill: {
      color: theme.colors.black,
      transparency: 25,
    },
    line: {
      color: theme.colors.inmarketGreen,
      width: 1,
    },
    ...options,
  },
});

const greeLineRight = (index: number): ShapeProps => ({
  shapeName: 'line',
  options: {
    line: {
      color: theme.colors.inmarketGreen,
      width: 3,
      endArrowType: 'triangle',
    },
    h: 0,
    w: 1.56 - applyPyramidXOffset(index),
    x: 8.05 + applyPyramidXOffset(index),
    y: 3.41 + applyPyramidYOffset(index),
  },
});

export const shapes: ShapeProps[] = [
  boxWithGreenOutline({
    h: 3.67,
    w: 3.61,
    x: 0.31,
    y: 0.89,
  }),
  boxWithGreenOutline({
    h: 1.09,
    w: 3.61,
    x: 0.31,
    y: 4.79,
  }),
  boxWithGreenOutline({
    h: 1.22,
    w: 8.37,
    x: 4.39,
    y: 0.89,
  }),
  ...pyramidMetrics.map((_, index) => greeLineRight(index)),
];
